<template>
    <div class="contact" :class="stepActive == 1 ? 'bg-gray' : ''">
        <div class="top">
            <div class="title">Online Assessment</div>
        </div>
        <div class="con">
            <div class="title">
                Online Assessment Form for Australian and New Zealand University
            </div>
        </div>
        <div class="step">
            <el-steps :active="stepActive" align-center finish-status="success">
                <el-step title="Test Questions"></el-step>
                <el-step title="Personal Information"></el-step>
                <el-step title="Submit Successfully"></el-step>
            </el-steps>
        </div>
        <div v-if="stepActive == 0">
            <div class="form">
                <div class="form-list" v-for="item in questionList">
                    <div class="form-title">{{ item.title }}:</div>
                    <div class="question-lists">
                        <div class="question-list" v-for="question in item.children">
                            <div class="question-title">{{ question.name }}:</div>
                            <el-radio-group v-if="question.type == 'radio'" v-model="question.active">
                                <el-radio v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-radio>
                            </el-radio-group>
                            <el-checkbox-group v-if="question.type == 'checkbox'" v-model="question.active">
                                <el-checkbox v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                            <div class="tip" v-if="question.tip">{{ question.tip }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="submitForm">Submit</el-button>
            </div>

        </div>
        <div v-if="stepActive == 1">
            <div class="step1">
                <!-- <p class="score">您的评分：<span>{{ totalScore }}</span>分</p> -->
                <div class="step-1">
                    <div class="input-title"><span>*</span>Name</div>
                    <el-input placeholder="Please input your name" v-model="form.name"></el-input>
                    <div class="input-title"><span>*</span>Email</div>
                    <el-input placeholder="Please input your email" v-model="form.email"></el-input>
                    <div class="input-title">Mobile Number</div>
                    <el-input placeholder="Please input your mobile number" v-model="form.mobile"></el-input>
                    <div class="input-title">Source</div>
                    <el-input placeholder="Please input your source" v-model="form.source"></el-input>
                    <div class="input-title">Institution/Program</div>
                    <el-input placeholder="Please input your institution/ program" v-model="form.institution"></el-input>
                    <div class="input-title"><span>*</span>WeChat Account Number</div>
                    <el-input placeholder="Please input your WeChat account number" v-model="form.wx_code"></el-input>
                    <div class="input-title">Message</div>
                    <el-input placeholder="Please input your message about" v-model="form.about"></el-input>
                    <div class="input-title">Attachment</div>
                    <el-radio v-model="form.reportType" label="1">Upload Image</el-radio>
                    <el-radio v-model="form.reportType" label="2">Upload File</el-radio>
                    <el-upload ref="child1" class="upload-demo"
                        :action="form.reportType == 1 ? host + '/VisApi/uploadImg' : host + '/VisApi/uploadfile'"
                        :on-success="successReport1" :before-remove="removeReport1" :file-list="fileList"
                        :accept="form.reportType == 1 ? '.png, .jpg' : '.rar, .zip, .xls, .xlsx, .doc, .docx'"
                        :before-upload="beforeAvatarUpload1" :on-exceed="onExceedFn1" :limit="1">
                        <el-button type="primary">Click to upload file</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                Only upload {{ form.reportType == 1 ? 'png, jpg' : "rar, zip, xls, xlsx, doc, docx" }} files
                            </div>
                        </template>
                    </el-upload>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="backFn(0)">Back to Test Questions</el-button>
                <el-button type="primary" class="btn" @click="subFn">Submit</el-button>
            </div>
        </div>
        <div v-if="stepActive == 2">
            <p class="step2">
                Thank you for your trust! Your information has been successfully submitted! <br>
                We have received your evaluation information. We will contact you as soon as possible to provide
                preliminary
                conclusions and suggestions. <br>
                If urgent processing is required, please indicate "urgent" in the message and specify the reason. The
                New Legend
                Visa Service Team is happy to assist you. <br>
                Our team comprises officially certified registered migration agents from Australia and New Zealand, who
                have
                been in the industry for 10 years and have achieved positive results for over 30,000 clients. <br>
                We are in Sydney, and our working hours are from 9:00 am to 5:30 pm Sydney time. You are also welcome to
                add our
                customer service WeChat for timely communication.
                <img class="sandywx" src="../../assets/imgs/sandywx.png" alt="">
                <el-button type="primary" class="btn" @click="stepActive = 0">Re-test</el-button>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            totalScore: 0,
            stepActive: 2,
            questionList: [
                {
                    "title": "Basic Information",
                    "children": [
                        {
                            "name": "Application Level",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Preparatory/Undergraduate" },
                                { "name": "Taught Master's Program" },
                                { "name": "Research Master's Degree" },
                                { "name": "Doctor" },
                                { "name": "Diploma Program (VET)" }
                            ]
                        },
                        {
                            "name": "Proposed enrollment date",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Within 3 months" },
                                { "name": "3-6 months" },
                                { "name": "6-12 months" },
                                { "name": "Over 12 months" },
                                { "name": "Uncertain" }
                            ]
                        },
                        {
                            "name": "Budget (Tuition + Living Expenses/Year)",
                            "type": "radio",
                            "tip": "AUD stands for Australian Dollar",
                            "active": [],
                            "option": [
                                { "name": "AUD 30,000 - 40,000" },
                                { "name": "AUD 40,000 - 60,000" },
                                { "name": "AUD 60,000 - 80,000" },
                                { "name": "Above AUD 80,000" },
                                { "name": "Uncertain" }
                            ]
                        }
                    ]
                },
                {
                    "title": "Academic Background",
                    "children": [
                        {
                            "name": "Highest education level",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "High school/Vocational school" },
                                { "name": "College degree" },
                                { "name": "Undergraduate" },
                                { "name": "Master's degree" },
                                { "name": "Doctor" }
                            ]
                        },
                        {
                            "name": "Relationship between professional background and target major",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Same major" },
                                { "name": "Approximate Major" },
                                { "name": "Interdisciplinary (relevant courses/projects available)" }
                            ]
                        },
                        {
                            "name": "Grades/GPA",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Excellent (85% and above)" },
                                { "name": "Good (65% and above)" },
                                { "name": "General (50% and above)" },
                                { "name": "Uncertain/Unable to Provide" }
                            ]
                        }
                    ]
                },
                {
                    "title": "Language and Materials",
                    "children": [
                        {
                            "name": "English proficiency (if applicable)",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "IELTS 4.6" },
                                { "name": "IELTS 4.7" },
                                { "name": "PTE 50-65" },
                                { "name": "PTE 65+" },
                                { "name": "No score/Waiting for exam" }
                            ]
                        },
                        {
                            "name": "Whether there is a history of visa rejection",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "None" },
                                { "name": "Visa rejection in Australia" },
                                { "name": "Visa rejection by other countries" }
                            ]
                        },
                        {
                            "name": "Whether packing service is required",
                            "type": "checkbox",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Immigration planning" },
                                { "name": "PET English Training" },
                                { "name": "Student rental before landing" }
                            ]
                        }
                    ]
                },
                {
                    "title": "Risk and Personalized Demand",
                    "children": [
                        {
                            "name": "Is there a gap period/change of major after graduation?",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "None" },
                                { "name": "Yes (explainable)" },
                                { "name": "Yes (insufficient explanatory materials)" }
                            ]
                        },
                        {
                            "name": "Whether to plan to bring family members along",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Not carrying" },
                                { "name": "Spouse" },
                                { "name": "Children" },
                                { "name": "Spouse + Children" }
                            ]
                        },
                        {
                            "name": "Whether has work experience",
                            "type": "radio",
                            "tip": "If your goal is immigration or specific career development, please specify the target industry and long-term plan in your message.",
                            "active": [],
                            "option": [
                                { "name": "None" },
                                { "name": "1-2 years" },
                                { "name": "3-5 years" },
                                { "name": "Over 5 years" }
                            ]
                        }
                    ]
                }
            ],
            host: "/api",
            form: {
                name: '',
                email: '',
                mobile: '',
                reviewFileUrl: '',
                about: '',
                type_id: 2,
                reportType: '2',
                source:'',
                wx_code:'',
                institution:'',

            },
            file_url: [],
            fileList: [],
            loading: false,
        };
    },
    mounted() {
        this.stepActive = 0
    },
    methods: {
        backFn(index) {
            this.stepActive = index;
            window.scrollTo(0, 0);
        },
        onExceedFn1() {
            this.$message.error("Only upload one file at a time");
        },
        successReport1(a, b) {
            console.log(a, '-----1--21-1-1aaa');
            this.file_url = a.data;
            this.fileList.push(a.data);
            this.$message.success("Upload success");
            this.loading = false;
        },
        removeReport1() {
            this.file_url = [];
            this.fileList = [];
        },
        handleRemove1() {
            this.file_url = [];
            this.fileList = [];
        },
        beforeAvatarUpload1(rawFile) { },
        subFn() {
            if (!this.form.name) {
                this.$message.error('Please input your name')
                return
            }
            if (!this.form.email) {
                this.$message.error('Please input your email')
                return
            } 
            if (!this.form.wx_code) {
                this.$message.error('Please input your WeChat account')
                return
            }
            this.$http.review_add2({
                name: this.form.name,
                email: this.form.email,
                mobile: this.form.mobile,
                about: this.form.about,
                type_id: this.form.type_id,
                reviewtext: JSON.stringify(this.questionList),
                reviewNum: this.score,
                reviewFileUrl: this.file_url,
                source: this.form.source,
                wx_code: this.form.wx_code,
                institution: this.form.institution,
            }).then(res => {
                console.log(res, '------')
                this.$message.success('Submit success')
                this.stepActive = 2;
            })
        },
        submitForm() {
            // 计算总分
            // let totalScore = 0;
            // this.questionList.forEach(questionItem => {
            //     if (!Array.isArray(questionItem.children)) return;
            //     questionItem.children.forEach(child => {
            //         const optionScoreMap = child.option.reduce((map, option) => {
            //             const validScore = Number(option.score) || 0;
            //             map[option.name] = validScore;
            //             return map;
            //         }, {});
            //         switch (child.type) {
            //             case 'radio':
            //                 totalScore += optionScoreMap[child.active] || 0;
            //                 break;
            //             case 'checkbox':
            //                 child.active.forEach(activeName => {
            //                     totalScore += optionScoreMap[activeName] || 0;
            //                 });
            //                 break;
            //             default:
            //                 console.warn(`未处理的题型：${child.type}`, child);
            //                 break;
            //         }
            //     });
            // });
            this.stepActive = 1;
            window.scrollTo(0, 0);
            // this.totalScore = totalScore;
        },
    }
}
</script>

<style lang="less" scoped>
.bg-gray {
    background-color: #f1f1f1;
    padding-bottom: 10px;
}

.upload-demo {
    margin-top: 20px;
    margin-bottom: 40px;
}

.btn-con {
    margin: 0 auto 150px;
    display: flex;
    justify-content: center;
}

.contact {
    .step2 {
        margin: 50px auto 100px;
        font-size: 18px;
        text-align: center;

        .sandywx {
            width: 200px;
            height: 200px;
            display: block;
            margin: 10px auto 0;
        }
        .btn {
            margin: 20px auto;
        }
    }

    .step {
        max-width: 700px;
        margin: 30px auto;
    }

    .step1 {
        margin: 0 auto 70px;
        max-width: 600px;
        background-color: #fff;
        padding: 20px 40px;
        border-radius: 10px;

        .score {
            font-size: 20px;

            span {
                margin-right: 6px;
                color: #222222;
                font-size: 30px;
                font-weight: 500;
            }
        }

        .input-title {
            margin-top: 40px;
            color: #333;

            span {
                color: red;
                margin-right: 4px;
            }
        }
    }

    .btn {
        display: block;
    }

    .form {
        max-width: 900px;
        margin: 0 auto;
        margin-bottom: 50px;
        border: 1px solid #ccc;
        background-color: #fff;

        .form-title {
            font-size: 26px;
            font-weight: 500;
            margin: 20px 0;
            text-indent: 20px;
            color: #333;
        }

        .question-lists {
            display: flex;
            flex-wrap: wrap;
        }

        .question-list {
            width: 100%;
            display: inline-block;
            box-sizing: border-box;
            padding: 20px;
            line-height: 30px;
            border-bottom: 1px solid #ccc;
            background-color: #f1f1f1;
        }

        .question-list:nth-child(2n) {
            border-left: 1px solid #ccc;
        }

        .tip {
            font-size: 14px;
            line-height: 20px;
            color: #222222;
        }

        .question-title {
            font-size: 20px;
            margin-bottom: 10px;
        }
    }

    .con {
        max-width: 1200px;
        margin: 50px auto;
        box-sizing: border-box;
    }

    .title {
        font-size: 30px;
        font-weight: 600;
        text-align: center;
        margin: 20px 0;
    }

    .text {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;

        p {
            font-size: 16px;
            line-height: 30px;
            margin: 10px 0;
        }

        .border {
            border: 1px solid #ccc;
            padding: 10px;
            margin: 10px 0;
            border-radius: 10px;

            p {
                font-size: 14px;
                line-height: 20px;
                margin: 10px 0;
            }
        }
    }

    .top {
        width: 100vw;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-image: url('../../assets/imgs/concat_us.png');
        background-size: cover;
        transition: .3s all;
        background-position: center;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #222222;
            text-shadow: 3px 3px 5px #fff;
        }



        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover {
            background-size: cover;

            img {
                transform: scale(1.1);
            }
        }
    }

}


@media (max-width: 600px) {
    .contact {
        .top {
            height: 200px;

            .title {
                font-size: 30px;
            }
        }

        .con {
            padding: 0 20px;
        }

        .title {
            font-size: 20px;
        }

        .step {
            zoom: 0.7;
        }

        .step1 {
            padding: 10px 20px;
        }

        .step2 {
            font-size: 18px;
            margin: 100px auto 150px;
        }

        .step2+.btn {
            margin: 0 auto 30px;
        }

        .form {
            padding: 0 15px;
            box-sizing: border-box;

            .question-list {
                padding: 10px;
            }

            .form-title {
                font-size: 20px;
            }

            .question-title {
                font-size: 16px;
            }

            .question-list:nth-child(2n) {
                border-left: none;
            }

            .question-list {}
        }

        .text p {
            font-size: 14px;
        }

        .text {
            padding: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/en/evaluateStudent.vue